import { render } from "./V2SupportModalHero.vue?vue&type=template&id=33667375&scoped=true"
import script from "./V2SupportModalHero.vue?vue&type=script&lang=js"
export * from "./V2SupportModalHero.vue?vue&type=script&lang=js"

import "./V2SupportModalHero.vue?vue&type=style&index=0&id=33667375&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33667375"]])

export default __exports__